import { Button, Card, CardContent, CardHeader, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";
import Dropzone from "react-dropzone";
import toast from '@/components/Toast';

const UploadReport = ({setReport}) => {
  const [file, setFile] = useState([]);
  const [password, setPassword] = useState('');
  const [isLoading, setLoading] = useState(false);
  function analyze() {
    if(!password){
      toast({type: 'error', message: 'Please provide the password'});
      return;
    }
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");

    const formdata = new FormData();
    formdata.append("password", password);
    formdata.append("file", file[0], file[0].name);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      // redirect: 'follow'
    };

    setLoading(true);
    fetch("https://r78can1f37.execute-api.ap-south-1.amazonaws.com/prod/docs_parser", requestOptions)
      .then(response => response.json())
      .then(result => {
        if(result.report){
          setReport(result);
        }else{
          toast({ type: "error", message: result.reportType });
        }
        setLoading(false);
      })
      .catch(error => {
        toast({ type: "error", message: 'Sorry some error occured' });
        setLoading(false);
      });
  }
  return <Card>
  <CardHeader title="Step 2: Upload report"
    subheader="Upload the report you received in your email." />
  <CardContent>
    <Dropzone onDrop={acceptedFiles => {
      setFile(acceptedFiles);
    }}
    accept="application/pdf"
    >
      {({ getRootProps, getInputProps, isDragActive }) => (
        <section>
          <Box {...getRootProps({ className: 'dropzone' })} sx={{ p: 3, border: '1px dashed #ccc', cursor: 'pointer' }}>
            <input {...getInputProps()} />
            {file.length > 0 ? <Typography>{file[0]?.path}</Typography> :
              isDragActive ?
                <Typography>Drop the file here ...</Typography> :
                <Typography>Drag &lsquo;n&rsquo; drop the report here, or click to select file</Typography>
            }
          </Box>
        </section>)}
    </Dropzone>
    <Box mt={2}>
      <TextField
        label="Password you provided in step 1"
        fullWidth
        value={password}
        onChange={e => setPassword(e.target.value)}
      />
    </Box>
    <Box mt={2}>
      <Button variant="contained"
        onClick={analyze}
        disabled={isLoading}
        fullWidth>
        {isLoading ? 'Processing...': 'Analyse'}
      </Button>
    </Box>
  </CardContent>
</Card>
}

export default UploadReport;